import 'reflect-metadata';

import { SyncEvent } from "ts-events";

import { FirebaseConfiguration } from '../config/AppConfiguration';

// Import the functions you need from the SDKs you need
import { FirebaseApp, initializeApp } from "firebase/app";
import { Analytics, getAnalytics } from "firebase/analytics";
import { Messaging, getMessaging, getToken, onMessage, MessagePayload } from "firebase/messaging";

import { injectable } from 'tsyringe';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

@injectable()
export class NotificationService
{

	/**
	 * On Scan Requested
	 */
    public onMessage: SyncEvent<MessagePayload> = new SyncEvent<MessagePayload>();


    private _config: FirebaseConfiguration;

    private _token: string;


    private _app: FirebaseApp;

    //private _analytics: Analytics;

    private _messaging: Messaging;

    private _swRegistration?: ServiceWorkerRegistration;


    /**
     * Token getter
     */
    public get token(): string {
        return this._token;
    }


    /**
     * Constructor
     * 
     * @param config 
     */
    constructor(config: FirebaseConfiguration)
    {
        this._config = config;
    }


    /**
     * Init Firebase
     */
    public async init(): Promise<void>
    {
        this._app = initializeApp(this._config);
        //this._analytics = getAnalytics(this._app);
        this._messaging = getMessaging(this._app);

        onMessage(this._messaging, (payload) => {
            console.log('Message received. ', payload);
            this.onMessage.post(payload);
        });
                
        this._swRegistration = await this.initServiceWorker();
        if(!this._swRegistration) {
            console.warn("Push messaging is not supported");
        }

        // get token
        this._token = await getToken(this._messaging, { vapidKey: this._config['vapidKey'] });
    }


    public async initServiceWorker(): Promise<ServiceWorkerRegistration|null>
    {
        if("serviceWorker" in navigator && "PushManager" in window) {
            //Register the service worker
            const swReg = await navigator.serviceWorker.getRegistration();
            navigator.serviceWorker.ready.then(function(registration) {
                //console.log("A service worker is active:", registration.active);
                // At this point, you can call methods that require an active
                // service worker, like registration.pushManager.subscribe()
            });
            return swReg;
        }
        return null;
    }    

    public displayNotification()
    {
        if (window.Notification && Notification.permission === "granted") {
            this.thankYouNotification();
        }
        // If the user hasn't told if he wants to be notified or not
        // Note: because of Chrome, we are not sure the permission property
        // is set, therefore it's unsafe to check for the "default" value.
        else if (window.Notification && Notification.permission !== "denied") {
            Notification.requestPermission(status => {
            if (status === "granted") {
                this.thankYouNotification();
            } else {
                alert("You denied or dismissed permissions to notifications.");
            }
            });
        } else {
            // If the user refuses to get notified
            alert("You denied permissions to notifications. Please go to your browser or phone setting to allow notifications.");
        }
    }
    
    public thankYouNotification()
    {
        const options = {
            body: "Nyní můžete dostávat notifikace o volných termínech"
        };        
        this._swRegistration.showNotification("Děkujeme!", options);
    }

}